<template>
	<a-modal title="选择学校" :visible="visible" @cancel="handleCancel" :footer="null" :width="800" class="modal">
		<a-input class="input" placeholder="学校名称搜索" @change="searchSchool" v-model="inputValue"><a-icon slot="suffix" type="search" /></a-input>

		<div class="item-list">
			<template v-if="searchStatus == 0">
				<div class="item" v-for="item in schoolList" :key="item.id" @click="chooseSchool(item)">
					<a :href="item.link">{{ item.schoolName }}</a>
				</div>
			</template>
			<template v-if="searchStatus == 1">
				<div class="item" v-for="item in serachList" :key="item.id" @click="chooseSchool(item)">
					<a :href="item.link">{{ item.schoolName }}</a>
				</div>
			</template>
		</div>
	</a-modal>
</template>

<script>
export default {
	name: 'courseSchoolModal',
	props: {
		schoolList: {
			type: Array,
			default: []
		}
	},
	data() {
		return {
			// schoolList: [
			// 	{ id: 1, schoolName: '安广小学', url: 'https://www.baidu.com' },
			// 	{ id: 2, schoolName: '保底小学', url: 'www.baidu.com' },
			// 	{ id: 3, schoolName: '保定第一中心学校', url: 'www.baidu.com' },
			// 	{ id: 4, schoolName: '保定第三中心学校', url: 'www.baidu.com' },
			// 	{ id: 5, schoolName: '保定中学附属小学', url: 'www.baidu.com' },
			// 	{ id: 6, schoolName: '保底中学', url: 'www.baidu.com' },
			// 	{ id: 7, schoolName: '保定中学附属小学', url: 'www.baidu.com' },
			// 	{ id: 8, schoolName: '长安小学', url: 'www.baidu.com' },
			// 	{ id: 9, schoolName: '长安第一中心学校', url: 'www.baidu.com' }
			// ], // 学校列表
			serachList: [], // 搜索学校列表
			inputValue: '', // 搜索框内容
			visible: false,
			searchStatus: 0 // 0未搜索 1搜索
		};
	},
	watch: {
		// 模糊查询学校
		inputValue(newVal) {
			if (newVal) {
				this.searchStatus = 1
				this.serachList = [];
				this.schoolList.forEach(v => {
					if (v.schoolName.indexOf(newVal) >= 0) {
						this.serachList.push(v);
					}
				});
			} else if (newVal == '') {
				this.searchStatus = 0
				this.serachList = [];
			}
		}
	},
	methods: {
		init() {
			this.visible = true;
		},

		handleCancel() {
			this.visible = false;
		},
		searchSchool(e) {},
		chooseSchool(e) {}
	}
};
</script>

<style lang="scss" scoped>
.modal {
	padding: 40px;
}
.input {
	width: 350px;
}
.item-list {
	margin-top: 33px;

	.item {
		display: inline-block;
		min-width: 120px;
		height: 42px;
		box-shadow: 0px 2px 10px 0px rgba(102, 153, 255, 0.13);
		border-radius: 4px;
		border: 1px solid #ececec;
		font-size: 18px;
		margin-right: 24px;
		margin-bottom: 24px;
		padding: 8px 24px;
		box-sizing: border-box;
		cursor: pointer;
		a {
			color: #000000;
		}
		a:hover {
			font-weight: 600;
			color: #198fff;
		}
	}
}
</style>
